import React,{useEffect} from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
//import Toolbar from '@material-ui/core/Toolbar';
import Navbar from "components/Navbars/Navbar.js";
//import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
//import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import Snackbar from "components/Snackbar/Snackbar.js";

import {routes} from "routes.js";

import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import { connect } from 'react-redux'
import {actions}   from "actions"
import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/reactlogo.png";
//import Login from 'views/Auth/Login';
let ps;

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.layout === "/page") {
        return (
          <Route
            exact={prop.exact}
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    })} 
   
  </Switch>
);

const useStyles = makeStyles(styles);

const mapDispatchToProps = dispatch => {
  return { 
  }
}
const mapStatetoProps = state => {
  if (state?.commonReducers?.showToaster) {
    return {
      showToaster: state.commonReducers.showToaster,
      toasterMsg: state.commonReducers.toasterMsg,
      toasterType: state.commonReducers.toasterType
    }
  }
  return {}
}
function Page({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
    
    <Navbar
          routes={routes}
          hideLinks={true}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        /> 
        <div></div>
     
      <div ref={mainPanel}>
        <Snackbar openSnack={rest.showToaster} message={rest.toasterMsg} type={rest.toasterType} timeout={3000}/>
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
            
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )} 
        
      </div>
    </div>
  );
}
export default connect(mapStatetoProps, mapDispatchToProps)(Page)